export default __webpack_public_path__ + "static/media/box-sizing.83de12a6.png";